enum CompanyTypes {
  Manufacturer = 'Manufacturer',
  Installer = 'Installer',
  FacilityManagement = 'FacilityManagement',
}
export default CompanyTypes;
